module.exports = __webpack_public_path__ + "cznic.743272f357748ccd86073d8f7b5efdc2.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/images/cznic.png
// module id = ./frontend/images/cznic.png
// module chunks = 1